export default __webpack_public_path__ + "static/media/020-gallows.d9ff4135.png";